<template>
    <div :id="modalName">
        <b-modal :id="modalName" hide-footer size="lg" static>
            <template v-slot:modal-title>
                Edit Transfer ({{ referenceId }})
            </template>

            <b-form-row>
                <b-col cols="4">
                    <b-form-group id="input-group-date-created" label="Date Created:" label-for="input-date-created"
                        label-size="sm">
                        <b-form-datepicker id="input-date-created" v-model="core.date_created"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" class="mb-2">
                        </b-form-datepicker>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="select-group-from" label="From Location:" label-for="select-from" label-size="sm">
                        <b-form-select v-model="core.from" :options="locations" @change="renderOptions('from')">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="input-group-created-by" label="Created By:" label-for="input-created-by"
                        label-size="sm">
                        <b-form-input id="input-created-by" v-model="core.created_by" type="text" placeholder=""
                            autocomplete="off" disabled>
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col cols="4">
                    <b-form-group id="input-group-date-received" label="Date Received:" label-for="input-date-received"
                        label-size="sm">
                        <b-form-datepicker id="input-date-received" v-model="core.date_received"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" class="mb-2">
                        </b-form-datepicker>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="select-group-to" label="To Location:" label-for="select-to" label-size="sm">
                        <b-form-select v-model="core.to" :options="locations" @change="renderOptions('to')">
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="input-group-received-by" label="Received By:" label-for="input-received-by"
                        label-size="sm">
                        <b-form-input id="input-received-by" v-model="core.received_by" type="text" placeholder=""
                            autocomplete="off" disabled>
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-table-simple hover small caption-top bordered responsive>
                <b-thead head-variant="dark">
                    <b-tr>
                        <b-th class="img"></b-th>
                        <b-th>SKU</b-th>
                        <b-th class="text-center qty">QTY</b-th>
                        <b-th></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(line, index) in lines" :key="index">
                        <b-td class="text-center">
                            <b-img-lazy v-if="line.url" class="products-thumbs" :src="line.url"></b-img-lazy>
                        </b-td>
                        <b-td>
                            <!-- {{ line.sku }} -->
                            <autosuggest-instance :key="index" :idx="index" @suggestFirstRow="suggestFirstRow"
                                @onSelectedRow="onSelectedRow" :ref="'skuinput' + index" />
                        </b-td>
                        <b-td class="text-center">
                            <b-form-input :id="'input-qty-' + index" v-model="lines[index].qty" type="text" size="sm"
                                autocomplete="off" class="input-qty">
                            </b-form-input>
                        </b-td>
                        <b-td class="text-center">
                            <b-link @click="deleteRow(index)" class="icon-danger"><i class="fas fa-trash-alt"></i>
                            </b-link>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>

            <b-button type="submit" variant="success" @click="editTransfer">
                <span v-if="submitting">
                    <b-spinner small type="grow"></b-spinner>
                    Updating...
                </span>
                <span v-else>Update</span>
            </b-button>
        </b-modal>
    </div>
</template>

<script>
import { VueAutosuggest } from "vue-autosuggest"
import AutosuggestInstance from '../../../../../pages/user/inventory/products/AutosuggestInstance'
export default {
    props: [
        'referenceId'
    ],

    components: {
        VueAutosuggest,
        AutosuggestInstance
    },

    data() {
        return {
            modalName: 'modal-warehousing-stocktransfer-edit-transfer',
            core: [],
            lines: [],
            deletes: [],
            locations: ['BSG', 'Road'],
            submitting: 0
        }
    },

    methods: {
        suggestFirstRow(idx, sku, description, rate, url, qoh, cost, available, mpn, lastCost, qoo, vendor) {
            if (!this.skuExists(sku)) {
                this.deletes.push[this.lines[idx]]
                this.lines[idx].url = url
                this.lines[idx].sku = sku
            } else {
                this.$nextTick(() => {
                    this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = this.lines[idx].sku
                    this.showAlertBox('error', 'SKU already exists!', 'Reverting back to original SKU.')
                })
            }
        },

        onSelectedRow(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed, available, mpn, lastCost, qoo, vendor) {
            if (!this.skuExists(sku)) {
                this.deletes.push[this.lines[idx]]
                this.lines[idx].url = url
                this.lines[idx].sku = sku
            } else {
                this.$nextTick(() => {
                    this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = this.lines[idx].sku
                    this.showAlertBox('error', 'SKU already exists!', 'Reverting back to original SKU.')
                })
            }
        },

        deleteRow(index) {
            this.deletes.push(this.lines[index])
            this.lines.splice(index, 1)
        },

        skuExists(sku) {
            return this.lines.some(function (o) { return o['sku'] === sku })
        },

        renderOptions(area) {
            if (area == 'from') {
                if (this.core.to == this.core.from) {
                    this.locations.forEach((loc, idx, array) => {
                        if (loc != this.core.from) {
                            this.core.to = this.locations[idx]
                        }
                    })

                }
            } else {
                if (this.core.from == this.core.to) {
                    this.locations.forEach((loc, idx, array) => {
                        if (loc != this.core.to) {
                            this.core.from = this.locations[idx]
                        }
                    })

                }
            }
        },

        getTransferLines() {
            let url = 'api/warehousing/stocktransfer/gettransferlines/' + this.referenceId
            axios.get(url, {})
            .then((res) => {
                this.core = res.data.core
                this.lines = res.data.lines

                this.$nextTick(() => {
                    this.lines.forEach((row, idx, array) => {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = row.sku
                    })
                })
            }, () => {
                this.has_error = true
            })
        },

        editTransfer() {
            this.submitting = 1

            let url = 'api/warehousing/stocktransfer/updatetransferlines'
            axios.post(url, {
                referenceId: this.referenceId,
                lines: this.lines,
                core: this.core,
                deletes: this.deletes
            })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Transfer Adjusted', 'Transfer adjusted successfully!')
                        this.$emit('updateRow')
                    } else {
                        this.showAlertBox('error', 'Error Adjusting Transfer', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
        }
    },

    computed: {

    },

    watch: {

    },

    mounted() {
        this.getTransferLines()
    }
}
</script>
<style lang="scss">
    #modal-warehousing-stocktransfer-edit-transfer {
        th.img { width: 1px; }
        th.qty { width: 67px; }

        .input-qty { text-align: center; }

        .products-thumbs {
            max-width: 75px;
            max-height: 75px;
        }
    }
</style>
